package diana.soleil.design.iraniancanadienbazzar.core.designsystem.component

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme

/**
 * Pill chip — used for filter/sort tabs (selectable) and static amenity tags. Selected = teal fill;
 * unselected = neutral container. Optional leading Material Symbols icon.
 */
@Composable
fun AppChip(
    label: String,
    modifier: Modifier = Modifier,
    selected: Boolean = false,
    leadingIcon: String? = null,
    onClick: (() -> Unit)? = null,
) {
    val container = if (selected) AppTheme.colors.primaryContainer else AppTheme.colors.surfaceContainer
    val content = if (selected) AppTheme.colors.onPrimary else AppTheme.colors.onSurface
    Row(
        modifier = modifier
            .background(container, AppTheme.shapes.pill)
            .then(if (onClick != null) Modifier.clickable(onClick = onClick) else Modifier)
            .padding(horizontal = AppTheme.spacing.md, vertical = AppTheme.spacing.sm),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs),
    ) {
        if (leadingIcon != null) {
            AppIcon(name = leadingIcon, size = AppTheme.sizes.iconSm, tint = content)
        }
        Text(text = label, style = AppTheme.typography.labelMd, color = content)
    }
}
